<script setup></script>

<template>
    <svg
        class="inline-block"
        viewBox="-51.2 -51.2 614.4 614.4"
        style="fill-rule: evenodd; clip-rule: evenodd; stroke-linejoin: round; stroke-miterlimit: 2"
        xml:space="preserve"
        fill="currentColor"
        stroke="currentColor"
        stroke-width=".005"
    >
        <g style="display: inline">
            <path
                d="M0-35.643h47.751c9.826 0 17.82 7.994 17.82 17.82C65.571-7.996 57.577 0 47.751 0H0c-9.826 0-17.82-7.996-17.82-17.823 0-9.826 7.994-17.82 17.82-17.82M0 30h47.751c26.368 0 47.82-21.454 47.82-47.823 0-26.368-21.452-47.82-47.82-47.82H0c-26.368 0-47.82 21.452-47.82 47.82C-47.82 8.546-26.368 30 0 30"
                style="fill-rule: nonzero"
                transform="translate(225.02 65.64)"
            />
            <path
                d="M0-30h-49.696c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15H0c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15"
                style="fill-rule: nonzero"
                transform="translate(112.586 89.37)"
            />
            <path
                d="M0-30h-95.846c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15H0c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15"
                style="fill-rule: nonzero"
                transform="translate(112.586 36.27)"
            />
            <path
                d="M0-30h-49.696c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15H0c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15"
                style="fill-rule: nonzero"
                transform="translate(112.586 228.16)"
            />
            <path
                d="M0-30h-95.846c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15H0c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15"
                style="fill-rule: nonzero"
                transform="translate(112.586 175.06)"
            />
            <path
                d="M0-30h-49.696c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15H0c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15"
                style="fill-rule: nonzero"
                transform="translate(112.586 366.94)"
            />
            <path
                d="M0-30h-95.846c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15H0c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15"
                style="fill-rule: nonzero"
                transform="translate(112.586 313.85)"
            />
            <path
                d="M0-30h-49.696c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15H0c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15"
                style="fill-rule: nonzero"
                transform="translate(112.586 505.73)"
            />
            <path
                d="M0-30h-95.846c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15H0c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15"
                style="fill-rule: nonzero"
                transform="translate(112.586 452.63)"
            />
            <path
                d="M0-25.202a17.702 17.702 0 0 1 12.6-5.22h110.868a17.7 17.7 0 0 1 12.601 5.221 17.7 17.7 0 0 1 5.219 12.602c0 4.759-1.854 9.234-5.219 12.599a17.704 17.704 0 0 1-12.601 5.22H12.6C7.84 5.22 3.365 3.366 0 .001a17.706 17.706 0 0 1-5.22-12.602c0-4.76 1.854-9.235 5.22-12.601M12.6 35.22h110.868c12.772 0 24.781-4.974 33.814-14.006 9.032-9.033 14.006-21.042 14.006-33.815 0-12.774-4.974-24.783-14.006-33.814-9.032-9.032-21.041-14.007-33.814-14.007H12.6c-12.773 0-24.782 4.975-33.813 14.006-9.033 9.032-14.007 21.041-14.007 33.817 0 12.772 4.974 24.78 14.007 33.814C-12.181 30.246-.172 35.22 12.6 35.22"
                style="fill-rule: nonzero"
                transform="translate(212.42 199.21)"
            />
            <path
                d="M0-25.202a17.704 17.704 0 0 1 12.601-5.22H176.34c4.76 0 9.236 1.854 12.601 5.219A17.703 17.703 0 0 1 194.16-12.6c0 4.76-1.853 9.235-5.219 12.6a17.704 17.704 0 0 1-12.601 5.22H12.601C7.841 5.22 3.367 3.366 0-.001a17.704 17.704 0 0 1-5.219-12.601c0-4.76 1.854-9.235 5.219-12.6M12.601 35.22H176.34c12.774 0 24.783-4.975 33.814-14.006C219.186 12.183 224.16.174 224.16-12.6c0-12.775-4.974-24.785-14.006-33.817-9.032-9.031-21.041-14.005-33.814-14.005H12.601c-12.772 0-24.781 4.974-33.814 14.006-9.032 9.033-14.006 21.042-14.006 33.816 0 12.773 4.974 24.782 14.006 33.813C-12.181 30.245-.172 35.22 12.601 35.22"
                style="fill-rule: nonzero"
                transform="translate(212.42 338)"
            />
            <path
                d="M0 35.642h-237.42c-9.826 0-17.82-7.995-17.82-17.822 0-9.825 7.994-17.82 17.82-17.82H0c9.826 0 17.82 7.995 17.82 17.822 0 9.826-7.994 17.82-17.82 17.82M0-30h-237.42c-26.368 0-47.82 21.453-47.82 47.822 0 26.368 21.452 47.82 47.82 47.82H0c26.368 0 47.82-21.453 47.82-47.822C47.82-8.547 26.368-30 0-30"
                style="fill-rule: nonzero"
                transform="translate(462.44 446.36)"
            />
        </g>
    </svg>
</template>
